import React from 'react';
import LandingPageLayout from "../layout/LandingPageLayout";
import LandingPageDiveIntoMilesWidget from "./LandingPageDiveIntoMilesWidget";

import * as entendaOMercado from "../../../../img/landing-page/entenda-o-mercado.svg"
import * as valeAPena from "../../../../img/landing-page/vale-a-pena.svg"
import * as comecandoAcumular from "../../../../img/landing-page/comecando-a-acumular.svg"
import * as comoAcumular from "../../../../img/landing-page/como-acumular.svg"
import * as book from "../../../../img/landing-page/book.png"
import LandingPageForm from "./LandingPageForm";

const LandingPageDiveIntoMiles = ({ didSubmitted, submitted } = props) => {


    const widgetsData = [
        {
            icon: entendaOMercado,
            title: 'ENTENDA O MERCADO DE MILHAS',
            description: 'Veja como este mercado funciona, seus mitos e as vantagens das milhas aéreas.'
        },
        {
            icon: valeAPena,
            title: 'VALE A PENA JUNTAR MILHAS?',
            description: 'Conheça diferentes possibilidades para o uso das milhas e escolha a melhor para você.'
        },
        {
            icon: comecandoAcumular,
            title: 'COMEÇANDO A ACUMULAR',
            description: 'Saiba como os cartões de crédito e os programas de milhagem funcionam na prática.'
        },
        {
            icon: comoAcumular,
            title: 'COMO ACUMULAR AINDA MAIS',
            description: 'Dicas de promoções e vantagens exclusivas para você acumular mais, em menos tempo.'
        }
    ]

    return (
        <LandingPageLayout id="dive-into-miles" classAdd='offers-landing-page-to-dive-into-miles'>
            <div className="offers-landing-page-to-dive-into-miles__header">
                <div className="offers-landing-page-to-dive-into-miles__header--text">
                    <h2>MERGULHE NO MERCADO DE MILHAS</h2>
                    <p>
                        <strong>Quer começar a juntar milhas?</strong>
                        <br/>
                        Neste guia, vamos mostrar as principais formas de acúmulo de pontos e te ensinar como
                        fazer um bom
                        negócio com elas.
                    </p>
                </div>
                <img className="offers-landing-page-to-dive-into-miles__header--book" alt=""
                     src={book}/>

                <LandingPageForm
                    gaEventLabel="Ebook"
                    buttonText='BAIXAR E-BOOK'
                    buttonColor='red'
                    id="offers-landing-page-form-dive"
                    icon="icon-email"
                    message="Você receberá o e-book no seu e-mail!"
                    didSubmitted={didSubmitted}
                    submitted={() => submitted()}
                />

            </div>

            <div className="offers-landing-page-to-dive-into-miles__content">
                {
                    widgetsData.map((widget, index) =>
                        <LandingPageDiveIntoMilesWidget
                            key={index}
                            title={widget.title}
                            description={widget.description}
                            icon={widget.icon}
                        />
                    )
                }
            </div>

        </LandingPageLayout>
    );
};

export default LandingPageDiveIntoMiles;